function checkAndTriggerAuth() {
  if (!window.interceptor.userdata && !window._authInProgress) {
    window._authInProgress = true;
    console.info("routingHelper: Running initAuth");
    window.initAuth();
  }
}

const uncheckedStates = ["forms", "forms.render", "forms.renderpublic"];

// Wait for auth and config retrieval, and then check & prevent access to
// disabled/unauthorized microapps
function checkPerms($rootScope, toastr, name) {
  if ($rootScope.publicMode) return;
  return $rootScope.initReady.then(config => {
    const microapp = name.split(/[-.]/)[0];
    if (microapp !== "container" && uncheckedStates.indexOf(name) === -1) {
      const app = config.appDetails.find(a => a.appId === microapp);
      if (app && !(app.enterpriseHasApp && app.isUserAuthorized)) {
        console.warn("Access denied", {
          enterpriseHasApp: app.enterpriseHasApp,
          isUserAuthorized: app.isUserAuthorized
        });
        window.location.href = "/#/";
        toastr.error("Access denied");
        return Promise.reject(new Error("Access denied to " + name));
      }
    }
  });
}

window.getRoutingHelper = function($stateProvider) {
  return {
    getStateProvider: () => $stateProvider,
    state: (name, config) => {
      config.resolve = { ...(config.resolve || {}) };
      config.resolve._dummy = [
        "$rootScope",
        "toastr",
        ($rootScope, toastr) => checkPerms($rootScope, toastr, name)
      ];
      config.resolve._dummy2 = () => checkAndTriggerAuth();
      return window.getRoutingHelper($stateProvider.state(name, config));
    }
  };
};



// WEBPACK FOOTER //
// ./src/utils/routingHelper.js